import { Config } from '@leverege/plugin';
import { Dialogs } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { Attributes } from '@leverege/ui-attributes';
import { BulkCreateItem } from '@leverege/molten/imagine';
// import BulkCreateItem from '../view/BulkCreateItem'

const {
  tf,
  t
} = I18N.ns('molten.imagine.actions.BulkCreateAction');
const create = (relationship, apiName) => {
  const {
    blueprint,
    path
  } = relationship;
  return {
    id: `openApi.action.${apiName}.${path}.BulkCreateItem`,
    name: tf('name', {
      blueprintName: blueprint.name
    }),
    matches: [{
      client: [null, 'GroupScreen'],
      use: ['contextMenu', 'mobileActionBar'],
      objectType: blueprint.type
    }, {
      client: ['MapBoxRolloverSelectionPointer', 'ListDataViewer'],
      use: ['contextMenu'],
      objectType: blueprint.type
    }],
    handles: cxt => {
      const {
        clientProps: {
          delegate
        }
      } = cxt;
      const can = delegate?.canCreate();
      return can === true;
    },
    layout: () => {
      return {
        sort: 'item.add2',
        sectionName: t('sectionName', {
          blueprintName: blueprint.name
        })
      };
    },
    appearance: () => {
      return {
        name: t('appearanceName', {
          blueprintName: blueprint.namePlural
        }),
        icon: Config.get('BlueprintActions', 'bulkCreateIcon', 'https://storage.googleapis.com/molten-ui-assets/bulk-create-action.png')
      };
    },
    perform: ({
      context
    }) => {
      const {
        clientProps: {
          delegate,
          objectType
        }
      } = context;
      Dialogs.show({
        component: BulkCreateItem,
        props: {
          delegate,
          relationship,
          getAttributes: () => {
            const attrs = Attributes.getAttributesFor(objectType);
            const modified = attrs.map(attr => ({
              ...attr,
              blueprint: {
                updatePath: `data/${attr.path}`
              }
            }));
            return modified;
          }
        }
      });
    }
  };
};
export default {
  create
};